import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../components/home/hero";
import { isPwaInstalled } from "../utils/pwaDetection";

const Home: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isPwaInstalled()) {
      navigate("/portal/dashboard");
    }
  }, [navigate]);

  // Only render the Hero if not a PWA install
  return (
    <div className="min-h-screen bg-gray-100">
      {!isPwaInstalled() && <Hero />}
    </div>
  );
};

export default Home;
